import React from 'react';
import ReactDOM from 'react-dom/client';
// Self-hosted display typeface (Space Grotesk) — bundled to our own origin by
// the build, so it satisfies the `font-src 'self'` CSP. Only the two weights the
// display tier uses (semibold/bold); body stays the system sans.
import '@fontsource/space-grotesk/latin-600.css';
import '@fontsource/space-grotesk/latin-700.css';
import './tailwind.css';
import './index.css';
import App from './App';
import { RestPlayerProvider } from './lib/restPlayer';
import { HintsProvider } from './lib/hints';
import { ToastProvider } from './components/Toast';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ToastProvider>
      <RestPlayerProvider>
      <HintsProvider>
        <App />
      </HintsProvider>
    </RestPlayerProvider>
    </ToastProvider>
  </React.StrictMode>
);

// Service worker: web push + a cached landing sample. No app-shell caching.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
